export class RecoverRequest {
    userName: string = "";
    requestedMethod: number = 1;
}
